import { Observable } from 'rxjs';
import {
  CantiereAndamento,
  Capitolo,
  CreateCantiereAndamentoDto,
  CreateCapitoloDto, CreateExtraDto, CreateIncassoDto, Extra, Incasso, UpdateCantiereAndamentoDto,
  UpdateCapitoloDto, UpdateExtraDto, UpdateIncassoDto
} from '../../models/capitoli.model'

export abstract class CapitoliPort {
  abstract getById(id: number): Observable<Capitolo>;
  abstract getByPreventivoId(idPreventivo: number): Observable<Capitolo[]>;
  abstract create(dto: CreateCapitoloDto): Observable<number>;
  abstract update(id: number, dto: UpdateCapitoloDto, updateVoci?: boolean): Observable<number>;
  abstract delete(id: number): Observable<void>;

  abstract getCantiereAndamentiByCantiereId(idCantiere: number): Observable<CantiereAndamento[]>;
  abstract createCantiereAndamento(dto: CreateCantiereAndamentoDto): Observable<any>;
  abstract updateCantiereAndamento(id: number, dto: UpdateCantiereAndamentoDto): Observable<any>;
  abstract deleteCantiereAndamento(id: number): Observable<void>;

  abstract getExtrasByCantiereId(idCantiere: number): Observable<Extra[]>;
  abstract createExtra(dto: CreateExtraDto): Observable<number>;
  abstract updateExtra(id: number, changes: UpdateExtraDto): Observable<number>;
  abstract deleteExtra(id: number): Observable<void>;

  abstract getIncassiByCantiereId(idCantiere: number): Observable<Incasso[]>;
  abstract createIncasso(dto: CreateIncassoDto): Observable<number>;
  abstract updateIncasso(id: number, changes: UpdateIncassoDto): Observable<number>;
  abstract deleteIncasso(id: number): Observable<void>;

  abstract setExtraStato(
    id: number,
    stato: string,
    createIncasso: boolean
  ): Observable<void>;
}
